var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-actions" }, [
    _c("span", { staticClass: "fa-stack", on: { click: _vm.details } }, [
      _c("i", { staticClass: "fa fa-circle-thin fa-stack-2x" }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa-caret-down fa fa-stack-1x",
        class: !_vm.val ? "down" : "up"
      })
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "fa-stack", on: { click: _vm.openDetails } }, [
      _c("i", {
        staticClass: "fa fa-circle-thin fa-stack-2x",
        attrs: { "data-toggle": "row" }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-eye fa-stack-1x" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Table/TableButtons.vue?vue&type=template&id=1505e06c&
// module id = null
// module chunks = 